import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import nexight from "../../Assets/Projects/nexight.svg";
import involab from "../../Assets/Projects/involab.svg";
import nexara from "../../Assets/Projects/nexara.svg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nexight}
              isBlog={false}
              title="Nexight"
              description="AI-agent analytics platform. I build autonomous LLM agents with LangGraph/LangChain and RAG pipelines over vector databases that turn raw data into actionable insight, served by a Python backend deployed on Azure Container Apps."
              ghLink="https://github.com/jk-0"
              demoLink="https://nexight.run/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={involab}
              isBlog={false}
              title="InvoLab"
              description="A Django/DRF invoicing and billing SaaS — invoice generation, client management and payments — containerized with Docker and shipped to Google Cloud Run through a CI/CD pipeline."
              ghLink="https://github.com/jk-0"
              demoLink="https://involab.io/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nexara}
              isBlog={false}
              title="Nexara"
              description="An AI-powered freelance marketplace — AI-driven matching connects clients and freelancers, with milestone-based escrow payments and low, transparent fees. Built end to end on a Django REST Framework backend, deployed on Google Cloud Run."
              ghLink="https://github.com/jk-0"
              demoLink="https://nexara.work/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
